import {
  ModelCreateModal,
  ModelCreateModalProps
} from '@rhino-project/ui-heroui';
import { RhinoPathEntries } from '@rhino-project/core';

const paths: RhinoPathEntries<'player'> = ['last_name', 'first_name'];

const RecruitingPlayerAdd = (
  props: Omit<ModelCreateModalProps<'player'>, 'model' | 'paths'>
) => {
  return <ModelCreateModal model="player" paths={paths} {...props} />;
};

export default RecruitingPlayerAdd;
